import { FinancialWorkspaceRecord } from 'modules/finance/components/FinancialWorkspaceDataCollection/types'

/**
 * Transforms raw row data to period value
 */
export const transformRowToPeriodValue = (row: {
  columnLabel: string
  amountInCents: string
  amountWithPrecision?: string | null
}) => ({
  label: row.columnLabel,
  amountInCents: row.amountInCents,
  amountWithPrecision: row.amountWithPrecision ?? undefined,
})

/**
 * Transforms raw child data to record
 */
export const transformChildToRecord = (child: {
  label: string
  rows: Array<{
    columnLabel: string
    amountInCents: string
    amountWithPrecision?: string | null
  }>
  categoryLabel?: string | null
  category?: string | null
}): FinancialWorkspaceRecord => ({
  id: child.label,
  label: child.label,
  hasChildren: false,
  isChild: true,
  periodValues: child.rows.map(transformRowToPeriodValue),
  categoryLabel: child.categoryLabel,
  category: child.category,
})

/**
 * Transforms raw item data to record
 */
export const transformItemToRecord = (item: {
  id: string | number
  label: string
  rows: Array<{
    columnLabel: string
    amountInCents: string
    amountWithPrecision?: string | null
  }>
  children?: Array<{
    label: string
    rows: Array<{
      columnLabel: string
      amountInCents: string
      amountWithPrecision?: string | null
    }>
    categoryLabel?: string | null
    category?: string | null
  }> | null
  categoryLabel?: string | null
  category?: string | null
  active?: boolean
  imageUrl?: string | null
  // Backend provides hasChildren for FinanceFactSummaries (may have children even if not loaded)
  hasChildren?: boolean
  // Flag to mark this as a child row (LineItem/CustomCategory result) - leaf node
  isChild?: boolean
}): FinancialWorkspaceRecord =>
  ({
    id: item.id,
    label: item.label,
    imageUrl: item.imageUrl,
    active: item.active ?? undefined,
    // Use backend hasChildren if provided, otherwise compute from children array
    hasChildren: item.hasChildren ?? !!(item.children && item.children.length > 0),
    isChild: item.isChild,
    periodValues: item.rows.map(transformRowToPeriodValue),
    children: item.children?.map(transformChildToRecord),
    categoryLabel: item.categoryLabel,
    category: item.category,
  })
